import React from 'react';
import { Form, Input, Button, Typography, Row, Col, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { uri } from '../../backendUri';
import axiosApi from '../../axiosApi/axiosApi';

const { Title } = Typography;

const Login = ({setHasLoggedIn}) => {

  const onFinish = async (values) => {
    try {
      await axiosApi.post(`/vendor/login`, values);
      message.success('Login successful');
      setHasLoggedIn(true)
       
    } catch (error) {
      message.error(error?.response?.data?.message || 'Login failed');
    }
  };

  return (
    <Row  align="middle" >
      <Col xs={24}>
        <div style={{ padding: 24, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <Title level={3} style={{ textAlign: 'center' }}>Login</Title>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
              <Input />
            </Form.Item>
            <Form.Item name="password" label="Password" rules={[{ required: true }]}>
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <Button style={{ background: "#1677ff", color: "white" }} type="primary" htmlType="submit" block>Login</Button>
            </Form.Item>
          </Form>
         
        </div>
      </Col>
    </Row>
  );
};

export default Login;
